module.exports = __webpack_public_path__ + "img/resource_mask2.8f944518.png";